module.exports = "<div class=\"outer\" (scroll)=\"scrollEvent($event)\">\n  <div class=\"inner\"\n    (mousemove)=\"mouseMoveEvent($event)\"\n    (mouseup)=\"mouseUpEvent()\">\n    <ng-container *ngFor=\"let node of model.nodes\">\n      <editor-card [node]=\"node\"></editor-card>\n    </ng-container>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/editor/pane/pane.component.html
// module id = ./src/app/components/editor/pane/pane.component.html
// module chunks = main